module.exports = __webpack_public_path__ + "img/07.3c31fab9.jpg";